export default __webpack_public_path__ + "static/media/pickpacknewlogo.b4d67a96.svg";